import { gql } from "@apollo/client";
import PRODUCT_FRAGMENT from "@/fragments/product";

const CHECKOUT_FRAGMENT = gql`
	${PRODUCT_FRAGMENT}
	fragment checkoutAdressFragment on CheckoutAddress {
		city
		deliverable
		formatted
		geometry {
			coordinates
			type
		}
		state
		street1
		street2
		valid
		zip
	}

	fragment itemFragment on Item {
		id
		errors
		option
		product {
			...productFragment
		}
		productId
		quantity
		valid
		isDiscounted
		basePrice
		discounts {
			total
		}
		taxes {
			total
			cannabis
			sales
		}
	}

	fragment priceSummaryFragment on PriceSummary {
		discounts
		fees
		mixAndMatch
		rewards
		subtotal
		taxes
		total
	}

	fragment checkoutFragment on Checkout {
		address {
			...checkoutAdressFragment
		}
		createdAt
		id
		items {
			...itemFragment
		}
		orderType
		priceSummary {
			...priceSummaryFragment
		}
		pricingType
		redirectUrl
		updatedAt
	}
`;

export default CHECKOUT_FRAGMENT;
